import * as Sentry from "@sentry/nextjs";

import { env } from "../env/client.mjs";

export const captureException = (ex: unknown) => {
  if (env.NEXT_PUBLIC_APP_ENV !== "prod") {
    console.error(ex);
  }

  Sentry.captureException(ex);
};
